export default __webpack_public_path__ + "static/media/card-mc_vrt_pos.9768a2ae.svg";